<ng-container [ngSwitch]="errorCode$ | async">
  <ng-container *ngSwitchCase="b2i">
    <dcp-add-company-details-error></dcp-add-company-details-error>
  </ng-container>
  <ng-container *ngSwitchCase="cpea">
    <dcp-add-to-existing-contract-error></dcp-add-to-existing-contract-error>
  </ng-container>
  <ng-container *ngSwitchCase="payg">
    <dcp-new-contract-error></dcp-new-contract-error>
  </ng-container>
  <ng-container *ngSwitchCase="unavailable">
    <dcp-checkout-unavailable></dcp-checkout-unavailable>
  </ng-container>
  <ng-container *ngSwitchCase="restructure">
    <dcp-configure-restructure-error></dcp-configure-restructure-error>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <dcp-default-configurator-error></dcp-default-configurator-error>
  </ng-container>
</ng-container>
